export type OrderChargeTotals = { total: number; tax: number };

export function computeShippingAmountFromOrder(effOrder: any): OrderChargeTotals {
  const fees = effOrder?.order_charges?.[0]?.shipping_option || effOrder?.shipping_option || [];
  const total = fees.reduce((sum: number, fee: any) => sum + Number(fee?.shipping_amount || 0), 0);
  const tax = fees.reduce((sum: number, fee: any) => sum + Number(fee?.shipping_tax_amount || 0), 0);
  return { total, tax };
}

export function computeSpecialFeesFromOrder(effOrder: any): OrderChargeTotals {
  const fees = effOrder?.order_charges?.[0]?.specialfee || effOrder?.specialfee || [];
  const total = fees.reduce((sum: number, fee: any) => sum + Number(fee?.specialfee_amount || 0), 0);
  const tax = fees.reduce(
    (sum: number, fee: any) => sum + Number(fee?.specialfee_tax_amount ?? fee?.tax_amount ?? 0),
    0
  );
  return { total, tax };
}
